import React, { useEffect, useMemo, useState } from 'react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { getUploadedTime } from 'Data/components/FileListDownload/utils';
import AgGridTable from 'components/AGGridTable/AgGridTable';
import { Wrapper } from './ProcessingFilesList.styles';

const ProcessingFilesList = ({ filesList }) => {
	const gridStyle = useMemo(() => ({ height: '210px' }), []);
	const defaultColDef = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			resizable: true,
			sortable: true,
			filter: false,
		};
	}, []);
	const [rowData, setRowData] = useState();
	const columnDefs = [
		{
			headerName: 'File Name',
			field: 'fileName',
		},
		{ field: 'date', headerName: 'Date' },
		{ field: 'authorName', headerName: 'Author Name' },
		{
			field: 'downloadUrl',
			headerName: 'Download',
			cellRenderer: params => {
				let eGui = document.createElement('div');
				eGui.innerHTML = `<a href='${params.data.downloadUrl}'
			  target="_blank"
			  download="file.csv"
			  rel="noopener noreferrer"> Download </a>`;
				return eGui;
			},
		},
	];

	useEffect(
		() => {
			const data = filesList.map(el => {
				return {
					id: el.id,
					fileName: el.fileId,
					date: getUploadedTime(el.timeStamp),
					authorName: el.authorName,
					downloadUrl: el.downloadUrl,
				};
			});
			setRowData(data);
		},
		[filesList]
	);

	const gridOptions = {
		modules: AllModules,
		rowData,
		columnDefs,
		defaultColDef,
		suppressRowClickSelection: true,
		pagination: true,
		paginationPageSize: 5,
	};

	return (
		<Wrapper>
			<AgGridTable gridOptions={gridOptions} gridStyle={gridStyle} />
		</Wrapper>
	);
};

export default ProcessingFilesList;
